<template>
    <div>
        <div class="display-f just-b align-i-c">
            <div style="width: 90%;" class="display-f align-i-c">
                <el-form :model="formData" inline>
                    <el-form-item>
                        <el-date-picker style="width: 300px;" @change="dateChange" v-model="timeRange" type="daterange"
                            range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
                            value-format="timestamp" :picker-options="pickerOptions" clearable>
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-select style="width: 150px;" clearable v-model="formData.patientId" placeholder="姓名"
                            filterable remote default-first-option :remote-method="getPatientList"
                            :loading="patientLoading" reserve-keyword :popper-append-to-body="false"
                            popper-class="customSelectStyle">
                            <el-option v-for="item in patientList" class="option-item" :key="item.patientId"
                                :label="item.patientName" :value="item.patientId">
                                <span style="margin-right:60px">{{ item.patientName }}</span>
                                <span style="margin-right:60px">{{ item.sex == '0' ? '男' : '女' }}</span>
                                <span style="margin-right:60px">{{ item.year + '岁' + item.month + '月' }}</span>
                                <span style="margin-right:60px">{{ item.phone }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select style="width: 150px;" multiple collapse-tags clearable v-model="formData.settleTypes"
                            placeholder="结算类别" default-first-option :popper-append-to-body="false"
                            popper-class="customSelectStyle">
                            <el-option v-for="item in statusList" :key="item.code" :label="item.name"
                                :value="item.code">
                                <span class="fl">{{ item.name }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>

                        <el-select multiple collapse-tags clearable v-model="formData.medTypes" placeholder="医疗类别"
                            default-first-option :popper-append-to-body="false" popper-class="customSelectStyle">
                            <el-option v-for="item in medTypeList" :key="item.code" :label="item.name"
                                :value="item.code">
                                <span class="fl">{{ item.name }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item>
            <el-select style="width: 150px;" v-model="formData.checkType" placeholder="结算类型" clearable multiple
                collapse-tags>
                <el-option label="市卡" value="1"></el-option>
                <el-option label="省卡" value="2"></el-option>
                <el-option label="省内异地" value="3"></el-option>
                <el-option label="省外异地" value="4"></el-option>
            </el-select>
        </el-form-item> -->
                    <el-form-item>

                        <el-select multiple collapse-tags clearable v-model="formData.mdtrtCertTypes"
                            placeholder="就诊凭证类型" default-first-option :popper-append-to-body="false"
                            popper-class="customSelectStyle">
                            <el-option v-for="item in certTypeList" :key="item.code" :label="item.name"
                                :value="item.code">
                                <span class="fl">{{ item.name }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select style="width: 150px;" clearable v-model="formData.doctorId" placeholder="请选择医生"
                            filterable default-first-option :popper-append-to-body="false"
                            popper-class="customSelectStyle">
                            <el-option v-for="item in doctorOptions" :key="item.value" :label="item.label"
                                :value="item.value">
                                <span class="fl">{{ item.label }}</span>
                                <span class="select-flex">{{ item.phone }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select style="width: 150px;" clearable v-model="formData.ybPay" placeholder="医保支付金额"
                            filterable :popper-append-to-body="false" popper-class="customSelectStyle">
                            <el-option v-for="item in amountList" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <el-button type="primary" icon="el-icon-search" @click="init(1)">查询</el-button>

            </div>

            <el-button type="primary" plain style="border: 1px solid #347EFF;padding: 6px 12px;"
                @click="openYearExportDialog">历年导出</el-button>
            <el-button type="primary" plain style="border: 1px solid #347EFF;padding: 6px 12px;"
                @click="downLoadCloseAccount">导出</el-button>

        </div>
        <div class="mt16 " v-loading="loading" style="min-height: 400px;">
            <custom-table class="tableC" :column="closeAccountTable" :tableData="accountList" :showPages="false"
                max-height="600">
                <template slot="psnName" slot-scope="{row}">
                    <el-popover placement="top" width="250" trigger="hover">
                        <div class="size12">
                            <div>证件类型：{{ row.psnCertTypeName }}</div>
                            <div class="mt4">证件号码：{{ row.certno }}</div>
                            <div class="mt4">参保地：{{ computedName(clrOptinsList, row.insuredPlace) }}</div>
                        </div>
                        <div slot="reference">{{ row.psnName}}</div>
                    </el-popover>
                </template>
                <template slot="medType" slot-scope="{row}">
                    <div>{{ computedName(medTypeList, row.medType) }}</div>
                </template>
                <template slot="mdtrtCertType" slot-scope="{row}">
                    <div>{{ computedName(certTypeList, row.mdtrtCertType) }}</div>
                </template>


                <template slot="settleType" slot-scope="{row}">
                    <div class="display-f  align-i-c">
                        <div class="mr8" :class="row.settleType == 0 ? 'successCircle' : 'errorCirce'">
                        </div>
                        <div class="mr8">{{ row.settleType == 0 ? '收费' : '退费' }}
                        </div>
                        <el-popover v-if="row.refundFlag == 1" placement="bottom-end" width="306" trigger="hover"
                            popper-class="return-popover">
                            <div class="size12 color3F4 line18">
                                <div class="display-f just-b align-i-c">
                                    <div>患者：<span class="color1F2 font600">{{ row.patientName }}</span></div>
                                    <div>操作员：<span class="color1F2 font600">{{ row.tollCollector?row.tollCollector:'--'
                                            }}</span></div>
                                </div>
                                <div class="line mt6"></div>
                                <div class="mt4 display-f just-b align-i-c">
                                    <span>{{ row.setlTime }}</span>
                                    <span>退费</span>
                                    <span>￥{{ row.medfeeSumamt }}</span>
                                </div>
                                <div class="mt4 ">
                                    <span>ID：{{ row.setlId }}</span>
                                </div>
                            </div>
                            <div slot="reference" class="parTag size14">已退</div>
                        </el-popover>
                    </div>
                </template>
                <template slot="setlId" slot-scope="{row}">
                    <div class="color189 pointer" @click="showDetailInfo(row.setlId)" type="text">{{ row.setlId }}
                    </div>
                </template>
            </custom-table>
            <div class="mt16 display-f just-b align-i-c">
                <div class="color3F4 size14 ">共<span class="color1F2 font600">{{ total }}</span>条数据，收费总金额<span
                        class="color1F2 font600">{{ moneyCensus.payMoney ? moneyCensus.payMoney : 0
                        }}</span>元，退费总金额<span class="color1F2 font600">{{
                        moneyCensus.refundMoney ? moneyCensus.refundMoney : 0 }}</span>元</div>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pages.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pages.pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
        <!-- 历年导出弹窗 -->
        <custom-dialog :visible.sync="showYearExportDialog" title="历年导出" :showFooter="false" dialogWidth="500px">
            <div class="year-export-content">
                <div v-for="item in yearExportList" :key="item.year" class="year-item">
                    <span class="year-label">{{ item.filedTxet }}：</span>
                    <span class="year-link" @click="downloadYearData(item.fileUrl)">{{ item.fileName }}</span>
                </div>
            </div>
        </custom-dialog>
        <custom-dialog :visible.sync="detailDialog" v-if="detailInfo.person" title="医保信息" :showFooter="false"
            dialogWidth="850px">
            <div class="w100_ size14 line20">
                <div class="w100_ borderD3D" style="background-color: #EBEAEE;">
                    <div style="padding: 8px 16px;" class="w100_ borderBox">
                        <el-descriptions :column="4" class="w100_" style="background-color: #EBEAEE;">
                            <el-descriptions-item label="持卡人">{{ detailInfo.person.psnName }}</el-descriptions-item>
                            <el-descriptions-item label="与患者关系">{{ computedRelation }}</el-descriptions-item>
                        </el-descriptions>
                    </div>
                    <div class="lineD3D"></div>
                    <div style="padding: 8px 16px;" class="w100_ borderBox">
                        <el-descriptions :column="4" class="w100_" style="background-color: #EBEAEE;">
                            <el-descriptions-item label="险种">{{ computedName(insuTypeList, detailInfo.person.insutype)
                                }}</el-descriptions-item>
                            <el-descriptions-item
                                label="参保地">{{computedName(clrOptinsList,detailInfo.person.insuredPlace)
                                }}</el-descriptions-item>
                            <el-descriptions-item label="类别">{{ computedName(psnTypeList, detailInfo.person.psnType)
                                }}</el-descriptions-item>
                            <el-descriptions-item label="公务员">{{ detailInfo.person.cvlservFlag == 1 ? '公务员' : '非公务员'
                                }}</el-descriptions-item>
                            <el-descriptions-item label="余额">{{ detailInfo.person.balc }}</el-descriptions-item>
                            <!-- <el-descriptions-item label="慢特病">{{ detailInfo.person.chronicSpecialIll?detailInfo.person.chronicSpecialIll:'--'
                            }}</el-descriptions-item> -->
                            <el-descriptions-item label="单位">{{
                                detailInfo.person.companyName ? detailInfo.person.companyName : '--'
                                }}</el-descriptions-item>
                        </el-descriptions>
                    </div>
                    <div class="lineD3D"></div>
                    <div style="padding: 8px 16px;" class="w100_ borderBox">
                        <el-descriptions :column="4" class="w100_" style="background-color: #EBEAEE;">
                            <el-descriptions-item label="患者">{{ detailInfo.person.patientName }}</el-descriptions-item>
                            <!-- <el-descriptions-item label="类型">{{ detailInfo.person.typeName?detailInfo.person.typeName:'--' }}</el-descriptions-item> -->
                            <el-descriptions-item label="医生">{{ detailInfo.person.doctorName }}</el-descriptions-item>
                        </el-descriptions>
                    </div>
                </div>
                <div class="mt16">
                    <custom-table class="tableC" :showPages="false" :column="detailTable" :tableData="detailInfo.items"
                        max-height="265">
                    </custom-table>
                </div>
                <div class="w100_ display-f align-i-c size14 line20 mt18" style="flex-direction:row-reverse;">
                    <el-popover placement="top-end" width="800" trigger="hover">
                        <div class="size12 color3F4 line18 display-f flex-w">
                            <tr class="w100_">
                                <td class="tdBox" style="">
                                    <div class="line20 size14 color1F2">{{
                                        detailInfo.settleDetail.fundPaySumamt ? detailInfo.settleDetail.fundPaySumamt :
                                        0 }}
                                    </div>
                                    <div>基金支付</div>
                                </td>
                                <td class="tdBox" style="">
                                    <div class="line20 size14 color1F2">{{
                                        detailInfo.settleDetail.hifpPay ? detailInfo.settleDetail.hifpPay : 0 }}</div>
                                    <div>基金统筹</div>
                                </td>
                                <td class="tdBox" style="">
                                    <div class="line20 size14 color1F2">{{
                                        detailInfo.settleDetail.cvlservPay ? detailInfo.settleDetail.cvlservPay : 0 }}
                                    </div>
                                    <div>公务员补贴</div>
                                </td>
                                <td class="tdBox" style="">
                                    <div class="line20 size14 color1F2">{{
                                        detailInfo.settleDetail.hifmiPay ? detailInfo.settleDetail.hifmiPay : 0 }}</div>
                                    <div>大病保险</div>
                                </td>
                                <td class="tdBox" style="">
                                    <div class="line20 size14 color1F2">{{
                                        detailInfo.settleDetail.hifobPay ? detailInfo.settleDetail.hifobPay : 0 }}</div>
                                    <div>大额补贴</div>
                                </td>
                                <td class="tdBox" style="">
                                    <div class="line20 size14 color1F2">{{
                                        detailInfo.settleDetail.mafPay ? detailInfo.settleDetail.mafPay : 0 }}</div>
                                    <div>医疗救助</div>
                                </td>
                                <td class="tdBox" style="">
                                    <div class="line20 size14 color1F2">{{
                                        detailInfo.settleDetail.hifesPay ? detailInfo.settleDetail.hifesPay : 0 }}</div>
                                    <div>补充医疗</div>
                                </td>
                                <td class="tdBox" style="">
                                    <div class="line20 size14 color1F2">{{
                                        detailInfo.settleDetail.othPay ? detailInfo.settleDetail.othPay : 0 }}</div>
                                    <div>其他</div>
                                </td>
                            </tr>
                            <tr class="w100_">
                                <td class="tdBox" style="">
                                    <div class="line20 size14 color1F2">{{
                                        detailInfo.settleDetail.psnPartAmt ? detailInfo.settleDetail.psnPartAmt : 0 }}
                                    </div>
                                    <div>个人负担</div>
                                </td>
                                <td class="tdBox" style="">
                                    <div class="line20 size14 color1F2">{{
                                        detailInfo.settleDetail.acctPay ? detailInfo.settleDetail.acctPay : 0 }}</div>
                                    <div>个人账户</div>
                                </td>
                                <td class="tdBox" style="">
                                    <div class="line20 size14 color1F2">{{
                                        detailInfo.settleDetail.psnCashPay ? detailInfo.settleDetail.psnCashPay : 0 }}
                                    </div>
                                    <div>个人现金</div>
                                </td>
                                <td class="tdBox" style="">
                                    <div class="line20 size14 color1F2">{{
                                        detailInfo.settleDetail.hospPartAmt ? detailInfo.settleDetail.hospPartAmt : 0 }}
                                    </div>
                                    <div>医院负担</div>
                                </td>
                                <td class="tdBox" style="">
                                    <div class="line20 size14 color1F2">{{
                                        detailInfo.settleDetail.acctMulaidPay ? detailInfo.settleDetail.acctMulaidPay :
                                        0 }}
                                    </div>
                                    <div>共济金</div>
                                </td>
                                <td class="tdBox" style="">
                                </td>
                                <td class="tdBox" style="">
                                </td>
                                <td class="tdBox" style="">
                                </td>
                            </tr>

                        </div>
                        <div slot="reference" class="size14 display-f ">
                            <div style="margin-right: 20px;color: #1890FF;">详情结算</div>
                            <div class="font500">刷卡金额：<span class="" style="color: #FE8F1F;">￥{{ $bigNumber(
                                    detailInfo.settleDetail.fundPaySumamt, '+', detailInfo.settleDetail.psnPartAmt)
                                    }}</span>
                            </div>
                        </div>
                    </el-popover>
                </div>

            </div>

        </custom-dialog>
    </div>
</template>

<script>
import { closeAccountListApi, getSetlDetailsApi, getTypeListApi, getCensusApi, downloadCloseAccountListApi,getYearDataApi } from '@/api/medInsuranceAccount.js';
import CustomTable from '@/components/customTable/customTable.vue';
import CustomDialog from '@/components/customDialog/index.vue';
import { patientInfom } from "@/api/patient"; // 病人列表请求
import { MedicalInsurance } from '../medicalInsurance.js';
import {  CommonDTO } from '@/DTO/index.js';
import { isEmptyArray,dictText } from '@/utils/validateBase';
export default {
    components: {
        CustomTable,
        CustomDialog
    },
    data() {
        return {
            loading: false,
            code: 200,//成功code码
            loading: false,
            formData: {
                startTime: null,
                endTime: null,
                patientId: null,
                settleTypes: null,
                medTypes: null,
                mdtrtCertTypes: null,
                doctorId: null,
                deptId: this.$session.get('deptId'),//医馆id
                ybPay:[],
            },
            timeRange: [],
            pages: {
                currentPage: 1,
                pageSize: 10
            },
            doctorOptions: [], // 医生选项
            certTypeList: [],//就诊凭证类型
            medTypeList: [],//就诊类别
            statusList: [],//状态列表
            insuTypeList: [],
            psnTypeList: [],//人员类别
            settleRelationList: [],//关系
            clrOptinsList:[],
            closeAccountTable: [
                { prop: 'setlTime', label: '结算时间', align: 'left' },
                { prop: 'patientName', label: '患者',  align: 'left' },
                { prop: 'psnName', label: '持卡人', slotName: 'psnName' },
                // { prop: 'certno', label: '身份证号', align: 'left' },
                { prop: 'medType', label: '医疗类别', slotName: 'medType', align: 'left' },
                { prop: 'mdtrtCertType', label: '就诊凭证类型', slotName: 'mdtrtCertType', align: 'left' },
                { prop: 'medfeeSumamt', label: '医疗费用总额', align: 'left' },
                { prop: 'ybPayMoney', label: '医保支付合计', align: 'left' },
                { prop: 'doctorName', label: '医生', align: 'left' },
                { prop: 'tollCollector', label: '收费员', align: 'left' },
                { prop: 'settleType', label: '结算类别', slotName: 'settleType', align: 'left' },
                { prop: 'setlId', label: '结算ID',slotName: 'setlId', align: 'left', width: '200' }
            ],
            accountList: [],
            total: 0,//总条数
            attach: {},//总收费和总退款
            detailDialog: false,
            detailInfo: {},
            showYearExportDialog: false,
            yearExportList: [],
            detailTable: [
                { prop: 'payItemName', label: '扣费项目', align: 'left' },
                { prop: 'ybCardNum', label: '医保编码', align: 'left' },
                { prop: 'unit', label: '单位', align: 'left' },
                { prop: 'pric', label: '单价', align: 'left' },
                { prop: 'cnt', label: '数量', align: 'left' },
                { prop: 'detItemFeeSumamt', label: '小计', align: 'left' },
            ],
            patientLoading: false,//患者远程搜索列表
            patientList: [],//患者列表
            moneyCensus: {},//金额统计
            deptId: this.$session.get('deptId'), // 当前医馆id
            sysTime:null,//系统时间
            amountList: [{ label: '0-800（不含）', value: ['0','799.99'] }, { label: '800（含）以上', value: ['800'] }],
            relationOption:[]
        }
    },
  async created() {
        let time=await this.getSysTime()
        this.relationOption = await CommonDTO.getYbOption({type: 'relation'})
        this.sysTime=this.$moment(time).valueOf();
        this.timeRange=[CommonDTO.startOfDay(time),CommonDTO.startOfDay(time)];
        this.$set(this.formData,'startTime',CommonDTO.startOfDay(time));
        this.$set(this.formData,'endTime',CommonDTO.startOfDay(time));
        this.$getDoctorOptions({ type: 0, status: 0 }); // 获取医生选项
        this.getSearchList();//获取搜索列表
        this.init()
    },
    computed: {
        computedName() {
            return function (list, code) {
                return list.filter(val => val.code == code).length > 0 ? list.filter(val => val.code == code)[0].name : code
            }
        },
         pickerOptions() {
            let that = this
            return {
                disabledDate(time) {
                    return time.getTime() > that.sysTime;
                }
            }
        },
        computedRelation(){
          return this.detailInfo.person.patientName == this.detailInfo.person.psnName ? '本人' : dictText(this.detailInfo.person.relation,this.relationOption)
        }
    },
    methods: {
        async getSysTime() {
            let res = await CommonDTO.getSystemTimeDTO()
            return new Date(res)
        },
        init(num) {
             if( !this.formData.startTime || !this.formData.endTime){
                this.$message.error('请选择时间')
                return false;
            }
            if(num){
                this.getAccountList(1);//获取结算列表
            }else{
                this.getAccountList();//获取结算列表
            }
            this.getCensus();//获取结算列表金额
        },
        //获取结算列表
        async getAccountList(num) {
            if(num){
                this.pages.currentPage=1
            }
            this.loading = true;
            if(!isEmptyArray(this.formData.ybPay)){
                if (this.formData.ybPay.length==1){
                    this.formData.ybPayMoneyDown = this.formData.ybPay[0]
                }else{
                    this.formData.ybPayMoneyDown = this.formData.ybPay[0]
                    this.formData.ybPayMoneyUp = this.formData.ybPay[1]
                }
            }
            // this.formData.startTime = _.toString(this.formData.startTime)
            // this.formData.endTime = _.toString(this.formData.endTime)
            let obj = {
                ...this.formData,
                ...this.pages
            }
            let { code, rows, total } = await closeAccountListApi(obj);
            if (code == 200) {
                this.accountList = rows;
                this.total = total
            }
            this.loading = false
        },
        //获取搜索列表状态
        async getSearchList() {
            const { certTypeList, statusList, medTypeList, insuTypeList, psnTypeList, settleRelationList,clrOptinsList } = await MedicalInsurance.getTypeList()
            this.certTypeList = certTypeList
            this.statusList = statusList
            this.medTypeList = medTypeList
            this.insuTypeList = insuTypeList
            this.psnTypeList = psnTypeList;
            this.settleRelationList = settleRelationList;
            this.clrOptinsList=clrOptinsList
        },
        //获取结算金额
        async getCensus() {

            let res = await getCensusApi(this.formData)
            if (res.code == 200) {
                this.moneyCensus = res.data
            }
        },
        //分页
        handleSizeChange(val) {
            this.pages.pageSize = val
            this.getAccountList()
        },
        handleCurrentChange(val) {
            this.pages.currentPage = val
            this.getAccountList()
        },
        //获取结算详情
        async showDetailInfo(setlId) {
            let { code, data } = await getSetlDetailsApi({ setlId })
            if (code == 200) {
                this.detailDialog = true
                this.detailInfo = data

            }

        },
        dateChange(val) {
            if (val) {
                this.formData.startTime = val[0];
                this.formData.endTime = val[1];
            } else {
                this.formData.startTime = null;
                this.formData.endTime = null;
                this.$message.error('请选择时间！')
            }
        },
        handleSelectionChange(val) {
            console.log(111111, val);
        },
        //远程搜索患者列表
        async getPatientList(query) {
            if (query !== '') {
                this.patientLoading = true;
                let { code, data } = await patientInfom({ name: query });
                this.patientList = [];
                if (code == 200) {
                    this.patientLoading = false;
                    data.forEach(item => {
                        this.$computeAge(item.birthday, item);
                    });
                    this.patientList = data;
                }
            } else {
                this.patientList = [];
            }

        },
        async downLoadCloseAccount() {
            if (!this.formData.startTime) {
                this.$message.error('请选择时间！')
            }
            this.formData.startTime = _.toString(this.formData.startTime)
            this.formData.endTime = _.toString(this.formData.endTime)
            this.loading=true
            downloadCloseAccountListApi(this.formData, {
                name: `医保结算列表`
            }).then(res => {
                this.loading = false
            }).catch(() => { this.loading = false })
        },
        // 打开历年导出弹窗
        async openYearExportDialog() {
            // 获取历年数据
            let data = await getYearDataApi()
            let deptInfo = data && data.find(item => item.deptCode == this.$session.get('deptInfo').deptCode)
            this.yearExportList =  deptInfo && deptInfo.fileInfo || []
            this.showYearExportDialog = true;
        },
        // 下载历年数据
        async downloadYearData(url) {
          window.open(url)
        },
    }

}
</script>

<style lang="less" scoped>
/deep/ .el-form-item {
    margin-bottom: 0px;

}

/deep/ .el-table thead {
    color: #5A6678;
}

.tableC /deep/ .el-table th.el-table__cell {
    background-color: #EBEAEE !important;
}

.customTable-wrap {
    border: 1px solid #EBEAEE;
    border-radius: 2px;
}

.primaryCircle {
    width: 6px;
    height: 6px;
    background: #347EFF;
    border-radius: 100%;
}

.errorCirce {
    width: 6px;
    height: 6px;
    background: #F54A45;
    border-radius: 100%;
}

.successCircle {
    width: 6px;
    height: 6px;
    background: #30C922;
    border-radius: 100%;
}

.line {
    width: 100%;
    height: 1px;
    background-color: #fff;
}

/deep/.el-descriptions__body {
    background-color: #EBEAEE;

}

/deep/.el-dialog__body {
    color: #3F4F66;
}

/deep/ .el-descriptions-item__content {
    color: #1F2329;
}

.tdBox {
    padding: 12px;
    background-color: #FFF0E1;
    border: 1px solid #fff;
    width: 100px;
    box-sizing: border-box;
}

.year-export-content {
    padding: 10px 0;
}

.year-item {
    display: flex;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #EBEAEE;
    
    &:last-child {
        border-bottom: none;
    }
}

.year-label {
    flex: 1;
    color: #606266;
    font-size: 14px;
}

.year-link {
    color: #1890FF;
    font-size: 14px;
    text-decoration: none;
    cursor: pointer;
    
    &:hover {
        text-decoration: underline;
    }
}
</style>